export default "__VITE_ASSET__88414a94__"